import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { SysConfig } from "__SYSDefault/Config";
import NewClientM from "./M/NewClientM";
import NewClientW from "./W/NewClientW";

/**
 * @augments {Component<Props, State>}
 */
class NewClient extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(NewClient.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    return ResponsiveX.Split({
      0: () => <NewClientM {...this.props} />,
      [SysConfig.WebUIWidth]: () => <NewClientW {...this.props} />
    });
  }

}

export default observer(NewClient);
